<side-dialog-title>Elevation Locator</side-dialog-title>

<side-dialog-content>
  <div class="elevation-parent">
    <div class="searchBox">
      <form>
        <mat-form-field
          class="address-field"
          (keydown.enter)="searchClick($event)"
        >
          <mat-label>Address</mat-label>

          <input
            #searchBox
            matInput
            [formControl]="addressSearch"
            type="text"
            autocomplete="off"
          />
          <button
            matSuffix
            mat-icon-button
            color="primary"
            (click)="currentLocationClick()"
          >
            <mat-icon>gps_fixed</mat-icon>
          </button>

          <mat-error *ngIf="!!addressSearch.errors">
            {{ getErrorText() }}
          </mat-error>
        </mat-form-field>
      </form>
      <button
        mat-raised-button
        color="primary"
        (click)="searchClick()"
        [disabled]="addressSearch.invalid"
      >
        Locate
      </button>
    </div>
    <div class="map-container">
      <div class="map" #map></div>
    </div>
  </div>
</side-dialog-content>

<side-dialog-actions>
  <button
    mat-raised-button
    color="primary"
    (click)="okClick()"
    [disabled]="addressSearch.invalid"
  >
    OK
  </button>
  <button mat-raised-button color="primary" (click)="cancelClick()">
    Cancel
  </button>
</side-dialog-actions>
